export default __webpack_public_path__ + "static/media/3033.ac370473.jpg";